// Rótulos pt-BR dos status e das origens das artes estendidas (spec §8).
// Fonte única: lista, revisão e o painel de arte do modelo avaliável usam estes mapas.

export const STATUS_LABEL = {
    draft: "rascunho",
    queued: "na fila",
    generating: "gerando",
    review: "em revisão",
    approved: "aprovada",
    rejected: "rejeitada",
    failed: "falhou",
};

// `designer` só aparece em aprovações antigas: hoje a arte editada fora entra como correção.
export const SOURCE_LABEL = { ai: "IA", designer: "designer", correction: "arte corrigida" };

/** Traduz o status; valores desconhecidos (ex.: "indisponível") saem crus. */
export const statusLabel = (status) => STATUS_LABEL[status] || status || "";

/** Traduz a origem da versão aprovada; valores desconhecidos saem crus. */
export const sourceLabel = (source) => SOURCE_LABEL[source] || source || "";
